import React from 'react';
import { Dialog, Box, Typography, Button } from '@mui/material';
import styles from './ConfirmDeleteModal.module.scss';

interface ConfirmDeleteModalProps {
  open: boolean;
  title?: string;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  open,
  onClose,
  onConfirm,
  title = 'this item',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: styles.dialogPaper }}
      disableRestoreFocus
    >
      <Typography variant="h6" className={styles.title}>
        Confirm Deletion
      </Typography>

      <Typography variant="body1" className={styles.description}>
        Are you sure you want to delete <strong>{title}</strong>? This action cannot be undone.
      </Typography>

      <Box className={styles.actions}>
        <Button onClick={onClose} className={styles.cancelBtn}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm} className={styles.deleteBtn}>
          Delete
        </Button>
      </Box>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
